import { Market, SportMatchModel } from '@nf/types/odds';
import { Button } from '@nf/ui';
import { Icon } from '@/components/icons/svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { matchStyles } from '../../match/match.style';
import { matchSpecialStyles } from '../match-special.style';
import { cx } from 'styled-system/css';
import { useEffect, useState } from 'react';
import { useOddsTableMarsContext } from '@/features/odds-table-mars/context';
import { useTranslations } from 'next-intl';
import { getSpecialSportSetting } from '@/services/settings.service';
import { useGetBetTypeName } from '@/hooks';
import { itemsEmptyCheck } from '@nf/utils-common/fpw/utils';
import { Maybe, MaybeMatch } from '@nf/utils-common/fpw/monadic';
import { SpecialSportSetting } from '@/settings/special-sport-setting';
import { betTypeService } from '@/services/bettype.service';
import { SpeacialMainBetTypes } from '../specail-main-bet-types';
import { SpeacialBetTypesOddsTable } from '../match-moreline-special/match-moreline-special-odds';
interface BaseBallSpecialBetTypeProps {
	isLoading: boolean
	match: SportMatchModel
	markets: Market[];
	isShowMatch: boolean;
	homeTeamName: string;
	awayTeamName: string;
}

export const MatchBaseBallAIOSpecial = ({
	isLoading,
	match,
	markets,
	homeTeamName,
	awayTeamName
}: BaseBallSpecialBetTypeProps) => {

	const [isOpen, setIsOpen] = useState<boolean>(false)
	const [selectBetType, setSelectBetType] = useState<string>('')
	const { IsLive } = match;
	const { sport } = useOddsTableMarsContext();
	const t = useTranslations('General');
	const [mainBetTypeMarket, setMainBetTypeMarket] = useState<Map<number, Market | undefined>>(new Map());
	const [otherMainBetTypeMarket, setOtherMainBetTypeMarket] = useState<Map<string | number, Market | undefined>>(new Map());
	const [moreBetTypeMarkets, setMoreBetTypeMarkets] = useState<Map<string | number, Market | undefined>[]>([]);
	const [betTypeMoreTabs, setBetTypeMoreTabs] = useState<{ betType: string, market: Market | undefined }[]>([]);
	const getBetTypeName = useGetBetTypeName();
	const baseSpecialSportSetting = getSpecialSportSetting(sport);
	const handleClickTab = (result: string) => {
		setSelectBetType(result);
	}

	useEffect(() => {
		itemsEmptyCheck(markets)
			.chain(() => Maybe(baseSpecialSportSetting))
			.chain(() => MaybeMatch(!isLoading))
			.fold(
				() => { },
				() => {
					const specialSportSetting: SpecialSportSetting = baseSpecialSportSetting;
					let mainGroupMap :  Map<number, Market | undefined>;
					if (specialSportSetting.mainSeriesBetType && match.BetTypes.find(betType => [8828, 8829, 8830].includes(betType.BetTypeId))) {
						mainGroupMap = betTypeService.getMainGroupMap(markets, specialSportSetting.mainSeriesBetType);
					} else { 
						mainGroupMap = betTypeService.getMainGroupMap(markets, specialSportSetting.mainGroupBetTypes);
					}
					setMainBetTypeMarket(mainGroupMap);
					const otherMainGroup = specialSportSetting.mainOtherGroup ? betTypeService.getOtherMainGroupMap(markets, specialSportSetting.mainOtherGroup) : new Map();
					setOtherMainBetTypeMarket(otherMainGroup);
					if (specialSportSetting.moreGroup) {
						const MoreGroupInfo = betTypeService.getMoreGroup(markets, specialSportSetting.moreGroup);
						setMoreBetTypeMarkets(MoreGroupInfo)
						const newBetTypeMoreTabs: { betType: string, market: Market | undefined }[] = [];
						MoreGroupInfo.forEach(group => {
							group && [...group].forEach(([betTypeSrc, market]) => {
								const betTypeString = typeof betTypeSrc === 'number' ? betTypeSrc.toString() : betTypeSrc.split(':')[0];
								if (!newBetTypeMoreTabs.some(item => item.betType === betTypeString && item.market?.Resourceid === market?.Resourceid)) {
									newBetTypeMoreTabs.push({ betType: betTypeString, market });
								}
							});
						});

						setBetTypeMoreTabs(newBetTypeMoreTabs);
						if (selectBetType === '' && newBetTypeMoreTabs.length > 0) {
							setSelectBetType(newBetTypeMoreTabs[0].betType??'');
						}

					}
				}
			)

	}, [isLoading, markets, IsLive])

	return (

		<>
			<Swiper
				className={matchSpecialStyles.slideOddsTable}
				modules={[Pagination]}
				pagination={true}
				spaceBetween={6}
				slidesPerView={1}
				autoplay={false}
				breakpoints={{
					1024: {
						slidesPerView: 2,
					},
				}}
			>
				{
					mainBetTypeMarket && mainBetTypeMarket.size > 0 ? (
						<SwiperSlide>
							<SpeacialMainBetTypes
								mainBetTypeMarketsMap={mainBetTypeMarket}
								match={match}
								homeTeamName={homeTeamName}
								awayTeamName={awayTeamName}
							/>
						</SwiperSlide>
					)  : null
				}
				{
					otherMainBetTypeMarket && otherMainBetTypeMarket.size > 0 ? (
						<SwiperSlide>
							<SpeacialMainBetTypes
								mainBetTypeMarketsMap={otherMainBetTypeMarket}
								match={match}
								homeTeamName={homeTeamName}
								awayTeamName={awayTeamName}
							/>
						</SwiperSlide>
					) : null
					
				}
			</Swiper>
			{
				moreBetTypeMarkets && moreBetTypeMarkets.length > 0 ?
					(
						<>
							<div
								className={matchStyles.noTeamNameMoreLine}
								data-full-width={true}
								onClick={() => {
									setIsOpen(true);
								}}
							>
								{t('lbl_MoreLines')}
							</div>
							<div
								className={cx('more-asian-lines', matchStyles.moreLine)}
								data-active={isOpen}
							>
								<div className={matchStyles.oddsTable}>
									<div className={cx(matchStyles.moreLineTab, matchStyles.moreLineTabBaseball)}>
										<Swiper
											className={cx(matchStyles.moreLineTabContainer, matchStyles.moreLineSlide)}
											slidesPerView="auto"
											freeMode={true}
											spaceBetween={6}
										>
											{
												betTypeMoreTabs.map((moreBetTypeTab) => (
													<SwiperSlide
														key={`SpeacialBetTypesTab_${moreBetTypeTab.betType}`}
														className={matchStyles.moreLineTabItem}
														data-active={selectBetType === moreBetTypeTab.betType}
														onClick={() => {
															handleClickTab(moreBetTypeTab.betType)
														}}
													>
														{getBetTypeName(Number(moreBetTypeTab.betType), sport, moreBetTypeTab.market)}
													</SwiperSlide>

												))
											}
										</Swiper>

									</div>
									<Swiper
										className={cx(matchSpecialStyles.bettypes, matchSpecialStyles.morelineBettypes)}
										modules={[Pagination]}
										pagination={true}
										freeMode={false}
										spaceBetween={6}
										slidesPerView={3}
										breakpoints={{
											480: {

												freeMode: true,
												slidesPerView: 'auto',
											},
										}}
									>
										{
											moreBetTypeMarkets.map((moreBetTypeMap, index) => {
												const firstBetTypeKey = [...moreBetTypeMap.keys()][0];
												const normalizedBetType = firstBetTypeKey.toString().split(':')[0];

												if (normalizedBetType === selectBetType) {
													return (
														<SwiperSlide
															key={`${moreBetTypeMap}_${index}`}
															className={cx(matchSpecialStyles.bettype)}
														>
															<SpeacialBetTypesOddsTable
																key={`BetTypesOddsTable_${firstBetTypeKey}_${index}`}
																BetTypeMarketsMap={moreBetTypeMap}
																match={match}
																homeTeamName={homeTeamName}
																awayTeamName={awayTeamName}
															/>

														</SwiperSlide>
													)
												}

												return null;
											})
										}
									</Swiper>
									{/* close button */}
									<div className={cx(matchStyles.moreLineFooter, 'baseball-aio-footer')} >
										<Button
											variant="primaryOutline"
											className={matchStyles.closeButton}
											onClick={() => {
												setIsOpen(false)
											}}
										>
											{t('lbl_btnClose')}
											<Icon name="close-big" />
										</Button>
									</div>
								</div>
							</div>
						</>

					)
					: null
			}
		</>
	);
}

